import { render, staticRenderFns } from "./MenuInterno.vue?vue&type=template&id=ee94f97c&scoped=true&"
import script from "./MenuInterno.vue?vue&type=script&lang=js&"
export * from "./MenuInterno.vue?vue&type=script&lang=js&"
import style0 from "./MenuInterno.vue?vue&type=style&index=0&id=ee94f97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee94f97c",
  null
  
)

export default component.exports